import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Blog } from 'src/app/model/blog';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}


  getAllBlogs(): Observable<Blog[]> {
    return this.http.get<Blog[]>(`${this.baseUrl}/api/blogs`);
  }

  getBlogById(id: string): Observable<Blog> {
    return this.http.get<Blog>(`${this.baseUrl}/api/blog/${id}`);
  }

}
